import { useEffect, useRef, useState } from 'react'
import { getCrmContacts, updateCrmContact, createCrmContact, linkDealContact, unlinkDealContact } from '../../db/api.js'
import Icon from '../../components/icons.jsx'

const demo = import.meta.env.DEV && import.meta.env.MODE === 'demo'
export default function DealPrimaryLead({ dealId, lead, Avatar, onSaved, onOpenDetails }) {
  const [open, setOpen] = useState(false)
  const [mode, setMode] = useState('select')
  const [name, setName] = useState('')
  const [search, setSearch] = useState('')
  const [rows, setRows] = useState([])
  const [selected, setSelected] = useState('')
  const [loading, setLoading] = useState(false)
  const [saving, setSaving] = useState(false)
  const [error, setError] = useState('')
  const root = useRef(null)
  const trigger = useRef(null)
  useEffect(() => {
    if (!open) return
    const outside = (event) => { if (!saving && !root.current?.contains(event.target)) setOpen(false) }
    document.addEventListener('pointerdown', outside)
    return () => document.removeEventListener('pointerdown', outside)
  }, [open, saving])
  useEffect(() => {
    if (!open || mode !== 'select') return
    let alive = true
    setLoading(true)
    const timer = setTimeout(() => {
      const request = demo ? import('../../demo/data.js').then((m) => m.getDemoLeadOptions(search)) : getCrmContacts(search)
      request.then((data) => { if (alive) setRows(Array.isArray(data) ? data : data.items || []) }).catch((err) => { if (alive) setError(err.message) }).finally(() => { if (alive) setLoading(false) })
    }, 180)
    return () => { alive = false; clearTimeout(timer) }
  }, [open, mode, search])
  const save = async (event) => {
    event.preventDefault()
    if (saving) return
    setError(''); setSaving(true)
    try {
      let contact
      let removedContactId = null
      let unlinkFailed = false
      if (demo) {
        const { saveDemoPrimaryLead } = await import('../../demo/data.js')
        contact = saveDemoPrimaryLead(dealId, { mode, name: name.trim(), contactId: selected })
        if (mode !== 'edit' && lead?.contact_id && lead.contact_id !== contact.contact_id) removedContactId = lead.contact_id
      } else if (mode === 'edit') {
        const updated = await updateCrmContact(lead.contact_id, { nome: name.trim() })
        contact = { ...lead, ...updated, contact_id: updated.id }
      } else {
        let base = rows.find((item) => item.id === selected)
        let contactId = selected
        if (mode === 'create') {
          base = await createCrmContact({ nome: name.trim() })
          contactId = base.id
        }
        const link = await linkDealContact(dealId, { contactId, isPrimary: true })
        contact = { ...base, ...link, contact_id: contactId, nome: base?.nome || name.trim() }
        // Trocar o lead principal substitui o anterior: sem isto o negócio continuaria
        // aparecendo no perfil do lead antigo (deal_contacts ainda o vincularia).
        if (lead?.contact_id && lead.contact_id !== contactId) {
          try { await unlinkDealContact(dealId, lead.contact_id); removedContactId = lead.contact_id }
          catch { unlinkFailed = true }
        }
      }
      onSaved(contact, { removedContactId })
      if (unlinkFailed) { setError('Lead principal trocado, mas não foi possível remover o vínculo do lead anterior.'); return }
      setOpen(false); trigger.current?.focus()
    } catch (err) { setError(err.message) }
    finally { setSaving(false) }
  }
  return <div className="dp-owners dp-primary-lead" ref={root} onKeyDown={(event) => { if (event.key === 'Escape' && open) { event.stopPropagation(); if (!saving) { setOpen(false); trigger.current?.focus() } } }}>
    <div className="dp-identity-row"><button type="button" className="dp-avatar-link" disabled={!lead} aria-label="Ver detalhes do lead" onClick={() => { setOpen(false); onOpenDetails?.(lead) }}><Avatar src={lead?.contact_pic || lead?.profile_picture || lead?.foto_perfil || lead?.avatar_url} /></button><button type="button" ref={trigger} className="dp-owners-trigger" aria-expanded={open} aria-label="Alterar lead principal" onClick={() => { setOpen(!open); setMode(lead ? 'edit' : 'select'); setName(lead?.nome || ''); setSelected(lead?.contact_id || ''); setSearch(''); setError('') }}>
      <span><span className="cv-row-label">Lead principal</span><span className="cv-row-value">{lead?.nome || 'Selecionar lead'}</span></span><span className="dp-owners-chevron" aria-hidden="true"><Icon n="chevron_d" s={14} /></span>
    </button></div>
    {open && <form className="dp-owners-menu dp-lead-menu" onSubmit={save}>
      <div className="dp-lead-tabs">{[['edit','Editar nome'],['select','Selecionar'],['create','Novo lead']].map(([value,label]) => <button type="button" key={value} disabled={saving || (value === 'edit' && !lead)} aria-pressed={mode === value} onClick={() => { setMode(value); setName(value === 'edit' ? lead?.nome || '' : ''); setError('') }}>{label}</button>)}</div>
      {mode === 'select' ? <><input aria-label="Buscar lead" placeholder="Buscar lead…" value={search} onChange={(event) => { setSearch(event.target.value); setSelected('') }} /><div className="dp-lead-options" role="group" aria-label="Leads disponíveis">{loading ? <p>Carregando…</p> : rows.length ? rows.map((item) => <button type="button" key={item.id} aria-pressed={selected === item.id} disabled={saving} onClick={() => setSelected(item.id)}>{item.nome}</button>) : <p>Nenhum lead encontrado.</p>}</div></> : <label className="dp-lead-name">{mode === 'edit' ? 'Nome do lead' : 'Nome do novo lead'}<input autoFocus required maxLength={200} value={name} disabled={saving} onChange={(event) => setName(event.target.value)} /></label>}
      {error && <p role="alert">{error}</p>}
      <footer><button type="button" disabled={saving} onClick={() => setOpen(false)}>Cancelar</button><button type="submit" disabled={saving || (mode === 'select' ? !selected || loading : !name.trim())}>{saving ? 'Salvando…' : mode === 'create' ? 'Criar e vincular' : 'Salvar'}</button></footer>
    </form>}
  </div>
}
